// extracted by mini-css-extract-plugin
module.exports = {"container":"BL","addOrRemoveFromListButton":"BM","addOrRemoveFromListIcon":"BN","checkIconStyle":"BO","cta":"BP"};